/* Marca la página como «ya se bajó» para que el botón del chat se achique.
   Es solo una clase en <html>: el tamaño lo decide custom-chat-button.css. */
(function () {
  'use strict';
  var root = document.documentElement;
  var UMBRAL = 240;
  var pendiente = false;

  function pintar() {
    root.classList.toggle('sofs-scrolled', window.scrollY > UMBRAL);
  }

  window.addEventListener('scroll', function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; pintar(); });
  }, { passive: true });

  pintar();
})();
